import React from 'react';
import { Box } from '@mui/material';

const PagePaper = ({ children, sx = {}, ...rest }) => (
  <Box
    boxShadow={25}
    sx={[
      {
        backgroundColor: 'background.paper',
        p: { xs: 1, sm: 2 },
        mb: 3,
      },
      sx,
    ]}
    {...rest}>
    {children}
  </Box>
);

export default PagePaper;
